/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import {
    TableComponent
} from "../../../CommonComponents";
import "../../styles.scss";
import Heading from "../../../../../components/Heading";
import { ReportsService } from "../../../../../services/api/reports";
import { downloadHubInscannedClickableReport } from "../../../../../utils/downloadUtils";
import { useRequestCancellation } from "../../../../../hooks/useRequestCancellation";
import { useNavigate, useLocation } from "react-router-dom";
import { showErrorMessage } from "../../../../../utils";

const HubInscannedClickableReport = () => {
    // Global request cancellation hook
    const { createNewRequest, isLatestRequest } = useRequestCancellation();

    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });
    const [reportData, setReportData] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    // Fetch report data


    const fetchReport = async () => {
        // 🔥 Create new request for cancellation support
        const { signal, requestId } = createNewRequest("hub-inscanned-clickable-report");

        setLoading(true);
        let shouldUpdateState = true;

        try {
            // Get form parameters from location.state
            const formParams = location.state || {};
            const { operationDate, hubId, type } = formParams;
            if (!operationDate || !hubId) {
                setLoading(false);
                return;
            }
            setReportData([]);
            const params = {
                operationDate: operationDate,
                hubId: hubId,
                ...(type && { type: type }),
                page: (pagination.current - 1),
                size: pagination.pageSize
            };

            const response = await ReportsService.getHubInscannedClickableReport(params, { signal });
            if (!response) {
                return;
            }

            const { data, count } = response;

            // 🔥 Check if this is still the latest request
            if (!isLatestRequest(requestId)) {
                shouldUpdateState = false;
            } else {
                setReportData(data || []);
                setPagination(prev => ({
                    ...prev,
                    total: count || 0,
                }));
            }
        } catch (error) {
            if (error.name === "AbortError") {
                return;
            }

            if (shouldUpdateState && isLatestRequest(requestId)) {
                showErrorMessage(error?.message);
                setReportData([]);
                setPagination(prev => ({
                    ...prev,
                    total: 0,
                }));
            }
        } finally {
            if (shouldUpdateState && isLatestRequest(requestId)) {
                setLoading(false);
            }
        }
    };


    // Fetch report data
    useEffect(() => {
        if (!location.state) return;
        const { operationDate, hubId, type } = location.state;
        if (!operationDate || !hubId) return;
        fetchReport();
        // eslint-disable-next-line
    }, [location.state, pagination.current, pagination.pageSize]);

    const handleTableChange = (paginationInfo) => {
        setPagination(prev => ({
            ...prev,
            current: paginationInfo.current,
            pageSize: paginationInfo.pageSize
        }));
    };

    const handleDownload = async () => {
        setDownloadLoading(true);
        try {
            const formParams = location.state || {};
            const { operationDate, hubId, type } = formParams;
            const downloadParams = {
                operationDate: operationDate,
                hubId: hubId,
                ...(type && { type: type })
            };

            await downloadHubInscannedClickableReport(downloadParams);
            message.success("Report downloaded successfully");
        } catch (error) {
            console.error("Download error:", error);
            message.error("Failed to download report");
        } finally {
            setDownloadLoading(false);
        }
    };

    const handleBack = () => {
        navigate("/inscan-vs-audit-report");
    };

    const getTableColumns = () => {
        return [
            {
                title: "AWB Number",
                dataIndex: "awbNumber",
                key: "awbNumber",
                sorter: true,
                width: 150,
                render: (text, record) => (
                    <span
                        style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => {
                            if (text) {
                                const url = `/shipment-tracker?awb=${text}`;
                                window.open(url, "_blank");
                            }
                        }}
                    >
                        {text || "-"}
                    </span>
                )
            },
            {
                title: "Date",
                dataIndex: "date",
                key: "date",
                sorter: true,
                width: 120,
            },
            {
                title: "Inscanned Shipments",
                dataIndex: "inscannedShipments",
                key: "inscannedShipments",
                sorter: true,
                width: 150,
            }
        ];
    };

    return (
        <div className="report-container">
            <Heading
                title="Hub Inscanned Shipments Report"
                navigateTo="/inscan-vs-audit-report"
                showBackButton={true}
                onBackClick={handleBack}
            />
            <Card className="report-card">
                <Row style={{ marginTop: 16 }}>
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            loading={downloadLoading}
                            onClick={handleDownload}
                        >
                            Download Report
                        </Button>
                    </Col>
                </Row>
            </Card>
            <TableComponent
                columns={getTableColumns()}
                dataSource={reportData}
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey={(record, index) => record.awbNumber || record.id || record.awb || index}
                style={{ marginTop: 32 }}
            />
        </div>
    );
};

export default HubInscannedClickableReport;
